module.exports = __webpack_public_path__ + "static/VerilySerifMono-af57249eeb7ca93011e81dbd8ee4f968.otf";